
(function (Drupal) {
  'use strict';

  // Gallery Slider
  Drupal.behaviors.tabs = {

    initialized: false,

    attach: function (context) {
      if (!this.initialized) {
        this.initialized = true;
        this.init(context);
      }
    },

    init: function (context) {

      /*
      *   This content is licensed according to the W3C Software License at
      *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
      */

      // For easy reference
      var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        enter: 13,
        space: 32
      };

      // Add or substract depending on key pressed
      var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1
      };

      var selectBoxes = document.querySelectorAll('.js-tabs');
      selectBoxes.forEach(function (selectBox) {

        var tablist = selectBox.querySelectorAll('[role="tablist"]')[0];
        var tabs = selectBox.querySelectorAll('[role="tab"]');
        var panels = selectBox.querySelectorAll('[role="tabpanel"]');
        var delay = determineDelay();
        var toggleButton = selectBox.querySelector('.tabs__selectBox-toggle');

        // For mobile if button isnt click hide it
        document.addEventListener('click', function (event) {
          if (event.target == toggleButton) {
            selectBox.classList.toggle('tabs--open');
            
            if (selectBox.classList.contains('tabs--open')){
              toggleButton.setAttribute('aria-expanded', true);
            }
            else {
              toggleButton.setAttribute('aria-expanded', false);
            }
          }
          else {
            selectBox.classList.remove('tabs--open');
            toggleButton.setAttribute('aria-expanded', false);
          }
        });


        // Bind listeners
        for (var i = 0; i < tabs.length; ++i) {
          addListeners(i);
        }

        function addListeners(index) {
          tabs[index].addEventListener('click', clickEventListener);
          tabs[index].addEventListener('keydown', keydownEventListener);
          tabs[index].addEventListener('keyup', keyupEventListener);

          // Build an array with all tabs (<button>s) in it
          tabs[index].index = index;
        }

        // When a tab is clicked, activateTab is fired to activate it
        function clickEventListener(event) {
          var tab = event.target;
          activateTab(tab, false);
          toggleButton.focus();
        }

        // Handle keydown on tabs
        function keydownEventListener(event) {
          var key = event.keyCode;

          switch (key) {
            case keys.end:
              event.preventDefault();
              // Activate last tab
              activateTab(tabs[tabs.length - 1]);
              break;
            case keys.home:
              event.preventDefault();
              // Activate first tab
              activateTab(tabs[0]);
              break;

            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
              determineOrientation(event);
              break;
          }
        }

        // Handle keyup on tabs
        function keyupEventListener(event) {
          var key = event.keyCode;

          switch (key) {
            case keys.left:
            case keys.right:
              determineOrientation(event);
              break;
            case keys.enter:
            case keys.space:
              activateTab(event.target);
              break;
          }
        }

        // When a tablistâ€™s aria-orientation is set to vertical,
        // only up and down arrow should function.
        // In all other cases only left and right arrow function.
        function determineOrientation(event) {
          var key = event.keyCode;
          var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
          var proceed = false;

          if (vertical) {
            if (key === keys.up || key === keys.down) {
              event.preventDefault();
              proceed = true;
            }
          }
          else {
            if (key === keys.left || key === keys.right) {
              proceed = true;
            }
          }

          if (proceed) {
            switchTabOnArrowPress(event);
          }
        }

        // Either focus the next, previous, first, or last tab
        // depening on key pressed
        function switchTabOnArrowPress(event) {
          var pressed = event.keyCode;

          // for (var x = 0; x < tabs.length; x++) {
          //   tabs[x].addEventListener('focus', focusEventHandler);
          // }

          if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
              if (tabs[target.index + direction[pressed]]) {
                tabs[target.index + direction[pressed]].focus();
              }
              else if (pressed === keys.left || pressed === keys.up) {
                focusLastTab();
              }
              else if (pressed === keys.right || pressed == keys.down) {
                focusFirstTab();
              }
            }
          }
        }

        // Activates any given tab panel
        function activateTab(tab, setFocus) {
          setFocus = setFocus || true;
          // Deactivate all other tabs
          deactivateTabs();

          // Remove tabindex attribute
          tab.removeAttribute('tabindex');

          // Set the tab as selected
          tab.setAttribute('aria-selected', 'true');

          // Get the value of aria-controls (which is an ID)
          var controls = tab.getAttribute('aria-controls');

          // Remove hidden attribute from tab panel to make it visible
          document.getElementById(controls).removeAttribute('hidden');

          // If on mobile hide select and update the button to reflect whats been selected
          selectBox.classList.remove('tabs--open');
          selectBox.querySelector('.tabs__selectBox-toggle').innerHTML = tab.dataset.title;

          // Set focus when required
          if (setFocus) {
            tab.focus();
          }
        }

        // Deactivate all tabs and tab panels
        function deactivateTabs() {
          for (var t = 0; t < tabs.length; t++) {
            tabs[t].setAttribute('tabindex', '-1');
            tabs[t].setAttribute('aria-selected', 'false');
            tabs[t].removeEventListener('focus', focusEventHandler);
          }

          for (var p = 0; p < panels.length; p++) {
            panels[p].setAttribute('hidden', 'hidden');
          }
        }

        // Make a guess
        function focusFirstTab() {
          tabs[0].focus();
        }

        // Make a guess
        function focusLastTab() {
          tabs[tabs.length - 1].focus();
        }

        // Determine whether there should be a delay
        // when user navigates with the arrow keys
        function determineDelay() {
          var hasDelay = tablist.hasAttribute('data-delay');
          var delay = 0;

          if (hasDelay) {
            var delayValue = tablist.getAttribute('data-delay');
            if (delayValue) {
              delay = delayValue;
            }
            else {
              // If no value is specified, default to 300ms
              delay = 300;
            }
          }

          return delay;
        }

        //
        function focusEventHandler(event) {
          var target = event.target;

          setTimeout(checkTabFocus, delay, target);
        }

        // Only activate tab on focus if it still has focus after the delay
        function checkTabFocus(target) {
          var focused = document.activeElement;

          if (target === focused) {
            activateTab(target, false);
          }
        }
        
        //////
        //This will make the tabs into a selectbox if there are too many tabs
        ///////
        var tempWidth =  selectBox.querySelector(".tabs__tabslist").offsetWidth; // need varible outside so when its in selectbox it does read that as the width
        var toggleSelect = function () {
          var listWrapper = selectBox.querySelector('.tabs__select').offsetWidth;
          var listWidth = selectBox.querySelector(".tabs__tabslist").offsetWidth;

          if (selectBox.classList.contains("tabs--selectBox")) {
            if(tempWidth + 50 <  listWrapper ) {
              selectBox.classList.remove("tabs--selectBox");
              selectBox.classList.remove("tabs--open");
            }
          }
          else {
            if (listWidth >= listWrapper - 50) {
              tempWidth = listWidth;
              selectBox.classList.add("tabs--selectBox");
            }
          }
        };

        window.addEventListener('resize', toggleSelect);
        toggleSelect();

      });
    }
  };
}(Drupal));